import { Component, effect, input } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";

@Component({
  selector: "app-standard-image",
  templateUrl: "./standard-image.component.html",
  styleUrl: "./standard-image.component.scss",
  imports: [UiKitModule],
  standalone: true,
})
export class StandardImageComponent {
  readonly imageUrl = input<string>();
  readonly fallbackImageUrl = input<string>();
  readonly iconSize = input<string>("150px");

  protected imageNotFound = false;

  constructor() {
    effect(() => {
      this.imageUrl();
      this.imageNotFound = false;
    });
  }

  handleImageNotFound($event: ErrorEvent) {
    if (!this.fallbackImageUrl()) {
      this.imageNotFound = true;
      return;
    }

    if (($event.target as HTMLImageElement).src == this.imageUrl()) {
      ($event.target as HTMLImageElement).src = this.fallbackImageUrl()!;
    } else {
      this.imageNotFound = true;
    }
  }

  resetImageSource() {
    this.imageNotFound = false;
  }
}
